
import Section from "../Section.vue";
import { getProvinces, getProvinceWithCode } from "../../utils/staticData";
import { vietnameseTextToSlug } from "../../utils/common";

export default {
  components: {
    Section,
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      isServer: true,
      baseImageURL: this.$config.BASE_URL_RESOURCE,
      defaultFilter: [
        { value: "", label: "Toàn quốc" },
        { value: "01", label: "Hà Nội" },
        { value: "79", label: "TP. Hồ Chí Minh" },
        { value: "48", label: "Đà Nẵng" },
        { value: "92", label: "Cần Thơ" },
      ],
      selectedFilter: "",
      prevFilter: "",
      provinces: getProvinces("array"),
      currentPage: 0,
      pageSize: 3,
      events: [],
      loading: this.loadingApi,
    };
  },
  props: {
    filter: {
      type: Boolean,
      default: false,
    },
    readMore: {
      type: Boolean,
      default: true,
    },
    linkTo: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    titleStyle: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.isServer = false;
    this.fetchNews();
    console.log("visibleEvents mounted:", this.visibleEvents);
  },
  computed: {
    sourceEvents() {
      return this.events;
    },
    pageCount() {
      return Math.ceil(this.sourceEvents.length / this.pageSize) || 0;
    },
    visibleEvents() {
      const start = this.currentPage * this.pageSize;
      return this.sourceEvents.slice(start, start + this.pageSize);
    },
    externalUrl() {
      return "https://tuoitre.vn/giao-duc/tuyen-sinh.htm";
    },
  },
  watch: {
    events(newVal) {
      this.currentPage = 0;
    },
  },
  methods: {
    openLink(url) {
      if (typeof window !== "undefined" && url) {
        window.open(url, "_blank");
      }
    },
    handleFilterChange(value) {
      if (!this.filter) return;
      this.prevFilter = this.selectedFilter;
      this.selectedFilter = value;
      this.$emit("eventFilterChange", getProvinceWithCode(value));
    },
    async fetchNews() {
      this.loadingApi = true;
      try {
        // call direct tuoitre API URL
        const url =
          "https://s1.tuoitre.vn/api-getlistnewstagbyurl.htm?c=getdata&tagurl=tuyen-sinh-dai-hoc-2026&page=1&size=10";
        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const json = await res.json();
        const raw = json?.Data || json?.data || [];
        // map similarly to prior logic
        this.events = raw.map((item) => {
          const dateObj = new Date(item.DistributionDate);
          return {
            id: item.NewsId,
            avatar: item.Avatar ? `https://cdn.tuoitre.vn/${item.Avatar}` : "",
            thumb: item.Avatar ? `https://cdn.tuoitre.vn/${item.Avatar}` : "",
            title: item.Title,
            location: item.ZoneName || "",
            Url: `https://tuoitre.vn${item.Url}`,
            num_of_register: 0,
            releaseDate: {
              date: dateObj.getDate().toString(),
              month: (dateObj.getMonth() + 1).toString(),
            },
          };
        });
      } catch (e) {
        console.error("failed to fetch news", e);
      } finally {
        this.loadingApi = false;
      }
    },
    getPath(title, id) {
      return vietnameseTextToSlug(title, id);
    },
    nextPage() {
      console.log("nextPage clicked", this.currentPage, "of", this.pageCount);
      if (this.currentPage < this.pageCount - 1) {
        this.currentPage += 1;
      }
    },
    prevPage() {
      console.log("prevPage clicked", this.currentPage, "of", this.pageCount);
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
  },
};
